module.exports = "<dynamic-table rows=\"gridRows\" columns=\"gridColumns\" items-per-page=\"options.itemsPerPage\"></dynamic-table>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/table/table.html
// module id = 738
// module chunks = 1